module.exports = __webpack_public_path__ + "static/media/guile.6bcce7ef.png";